import React from "react";
import { Data } from "../../../../components/Formatters/DateTime";

const columns = [
  {
    name: "Nº Pedido",
    selector: "sqPedidoProrrogacao",
    minWidth: "130px",
    center: true,
    sortable: true,
  },
  {
    name: "Data Pedido",
    selector: "dtPedidoProrrogacao",
    minWidth: "145px",
    center: true,
    sortable: true,
    cell: (row) => <Data value={row.dtPedidoProrrogacao} />,
  },
  {
    name: "Situação",
    cell: (row) => (row.situacaoProrrogacao !== null ? row.situacaoProrrogacao : row.situacaoPedido),
    minWidth: "250px",
    center: true,
    sortable: true,
  },

  {
    name: "Início Prorrogação",
    selector: "dtProrrogadaIni",
    minWidth: "190px",
    cell: (row) => (row.situacaoProrrogacao === "Aceito" ? <Data value={row.dtProrrogadaIni} /> : "-"),
    center: true,
    sortable: true,
  },
  {
    name: "Fim Prorrogação",
    selector: "dtProrrogadaFim",
    minWidth: "175px",
    cell: (row) => (row.situacaoProrrogacao === "Aceito" ? <Data value={row.dtProrrogadaFim} /> : "-"),
    center: true,
    sortable: true,
  },
  {
    name: "Dias Prorrogados",
    selector: "qtdDiasProrrogados",
    minWidth: "185px",
    center: true,
    sortable: true,
  },
];

const useColumns = () => ({ columns });

export default useColumns;
